import type { FaireProductEntity } from "../../entity_types/product";

export const p_wz4bffv2r5: FaireProductEntity = {
  token: "p_wz4bffv2r5",
  type: "product",
  name: "Garden of Love Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/db776d7b9e354d7adfabbfe7b953c365ac3abafc0763b878243e6b8c1036e09c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/042dda6b03afa967d05f746489594dae2faec8631d918ae4e4414d1b1c578a7d.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:21.463Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
